import {SxProps} from '@mui/material';

import CardMatchView from '../../../../../components/ApplicantMatchViewCard/CardMatchView';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';
import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {getMatchStatusColor} from '../../../../../utils/matchUtils';
import {Match} from '../../../dashboard/types/ApplicantMatchesTypes';

interface Props {
  match: Match;
  onClick?: (id: string) => void;
  shouldDisplayTopBorder?: boolean;
  bgColor: string;
  sx?: SxProps;
  isButton?: boolean;
}
export const MatchCard = ({match, onClick, shouldDisplayTopBorder, bgColor, sx, isButton = true}: Props) => {
  const clickHandler = () => {
    if (onClick) {
      onClick(match.resourceId);
    }
  };

  const childPaperStyles: SxProps = {
    minHeight: '364px',
    backgroundColor: bgColor,
    borderRadius: '0px 0px 16px 16px',
    backgroundImage: 'none',
    elevation: 0,
    boxShadow: 'none',
    ...(isButton && {
      '&:hover': {
        backgroundColor: orangeColors[6],
        cursor: 'pointer',
      },
    }),
    ...sx,
  };
  return (
    <EmpionPaper
      key={match.resourceId}
      data-testid='match-paper'
      sx={{
        ...childPaperStyles,
        ...(shouldDisplayTopBorder && {borderTop: '4px solid' + getMatchStatusColor(match.status)}),
      }}
      onClick={onClick && clickHandler}
    >
      <CardMatchView match={match} statusColour={getMatchStatusColor(match.status)} />
    </EmpionPaper>
  );
};
